/**
 * حالت نمایش PDF از `.env` — کلید `REACT_APP_PDF_VIEWER_MODE`
 *
 * - `iframe` (پیش‌فرض دسکتاپ): iframe + نمایشگر داخلی مرورگر
 * - `react-pdf`: pdf.js داخل React
 * - `gview` | `google` | `google-docs`: iframe سرویس Google (gview) — نیاز به URL عمومی فایل
 *
 * روی موبایل/ریسپانسیو نمایشگر native مرورگر (iframe/embed) — pdf.js برای فارسی مناسب نیست.
 */
export function getPdfViewerMode() {
    const raw = String(process.env.REACT_APP_PDF_VIEWER_MODE || 'iframe').trim().toLowerCase();
    if (raw === 'react-pdf') {
        return 'react-pdf';
    }
    if (raw === 'gview' || raw === 'google' || raw === 'google-docs' || raw === 'googledocs') {
        return 'gview';
    }
    if (raw === 'iframe' || raw === 'embed' || raw === 'native') {
        return 'iframe';
    }
    return 'iframe';
}
